// Librairies
import Dexie from 'dexie';
import Cookies from 'universal-cookie';
import { jwtDecode } from 'jwt-decode';
// Utils
import { createOfflineDb, OFFLINE_DB_PREFIX } from './OfflineDb';
import { createBootCache } from './BootCache';
import { createProjectSnapshot } from './ProjectSnapshot';
import { createOutbox } from './Outbox';
import { createIdMap } from './IdMap';
import { createSyncLog } from './SyncLog';
import { createPhotoStore } from './PhotoStore';

// Briques du hors-ligne de l'utilisateur connecté, créées à la demande
let current = null;

// Id de l'utilisateur du jeton
export const getCurrentUserId = () => {
    const token = new Cookies().get('token');
    if (!token) return null;
    try { return jwtDecode(token).id; }
    catch { return null; }
};

// Toutes les briques sur une même base (une par utilisateur)
export const createOfflineServices = (userId, dbName = OFFLINE_DB_PREFIX + userId) => {
    const db = createOfflineDb(dbName);
    return {
        userId, db,
        bootCache: createBootCache(db),
        snapshot: createProjectSnapshot(db),
        outbox: createOutbox(db, { userId }),
        idMap: createIdMap(db),
        syncLog: createSyncLog(db),
        photos: createPhotoStore(db),
        // Posé par SyncManager quand le hors-ligne est actif
        engine: null
    };
};

// Briques de l'utilisateur courant ; recréées si l'utilisateur change
export const getOfflineServices = () => {
    const userId = getCurrentUserId();
    if (!userId) return null;
    if (current?.userId !== userId) {
        current?.engine?.stop();
        current?.db.close();
        current = createOfflineServices(userId);
    }
    return current;
};

// Supprime la base locale d'un utilisateur (déconnexion)
export const deleteOfflineData = async (userId) => {
    if (!userId) return;
    if (current?.userId === userId) {
        current.engine?.stop();
        current.db.close();
        current = null;
    }
    await Dexie.delete(OFFLINE_DB_PREFIX + userId);
};

// Diagnostic : window.__offlineDebug.services().outbox.list()…
if (typeof window !== 'undefined') window.__offlineDebug = { services: getOfflineServices };
